module.exports = __webpack_public_path__ + "img/pos-leaderboard-badge-rank-4.be447ded.svg";